export const SUCCESS_MESSAGE = {
  RECOVERY_SUCCESS:
    'En breve recibirás un correo electrónico con tu contraseña',
};

export const ERROR_MESSAGE = {
  NETWORK_ERROR:
    'Ha ocurrido un error inesperado en el servidor. Por favor inténtelo de nuevo más tarde.',
};
